/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentVisibility
 */
export interface AttachmentVisibility {
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentVisibility
     */
    isPublic: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentVisibility
     */
    isVisibleInCp: boolean;
}

export function AttachmentVisibilityFromJSON(json: any): AttachmentVisibility {
    return AttachmentVisibilityFromJSONTyped(json, false);
}

export function AttachmentVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentVisibility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isPublic': json['isPublic'],
        'isVisibleInCp': json['isVisibleInCp'],
    };
}

export function AttachmentVisibilityToJSON(value?: AttachmentVisibility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isPublic': value.isPublic,
        'isVisibleInCp': value.isVisibleInCp,
    };
}


